import gql from 'graphql-tag';

export const MULTI_DUPLICATE_CREATIVE_MUTATION = gql`
  mutation MultiDuplicateCreatives($creativeIds: [ID!]!) {
    multiDuplicateCreatives(creativeIds: $creativeIds) {
      creatives {
        id
      }
      errors
    }
  }
`;
